// extracted by mini-css-extract-plugin
module.exports = {"carouselWrap":"CommentCarousel_carouselWrap__hmP0C"};